import { render, staticRenderFns } from "./LiveSession.vue?vue&type=template&id=533cad68&"
import script from "./LiveSession.vue?vue&type=script&lang=js&"
export * from "./LiveSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports